import React from "react";
import { Radio, Space } from "antd";
import { CATEGORY_OVERVIEW_SKU_FILTERS } from "@/ts/common-types";

type FilterMenuProps = {
  selectedRadioFilters: CATEGORY_OVERVIEW_SKU_FILTERS;
  setSelectedRadioFilters?: (value: CATEGORY_OVERVIEW_SKU_FILTERS) => void;
};

const RevenueUnitsFilterMenu: React.FC<FilterMenuProps> = ({
  selectedRadioFilters,
  setSelectedRadioFilters,
}) => {
  const handleChange = (e: any) => {
    if (setSelectedRadioFilters) {
      setSelectedRadioFilters(e.target.value);
    }
  };

  return (
    <div style={{ padding: "10px", background: "white", borderRadius: "8px" }}>
      <Radio.Group value={selectedRadioFilters} onChange={handleChange}>
        <Space direction="vertical">
          <Radio value={CATEGORY_OVERVIEW_SKU_FILTERS.REVENUE}>Revenue</Radio>
          <Radio value={CATEGORY_OVERVIEW_SKU_FILTERS.UNITS_SOLD}>Units Sold</Radio>
        </Space>
      </Radio.Group>
    </div>
  );
};

export default RevenueUnitsFilterMenu;
